











































































import { Template } from '@/models'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import VueJSONEditor from '@/components/VueJSONEditor.vue'

@Component({
  components: {
    VueJSONEditor
  }
})
export default class SaveTemplateModal extends Vue {
  @Prop({ required: false }) template: Template

  @Watch('template', { deep: true })
  onTemplateChanged() {
    this.updateTemplateSave()
  }

  private templateSave: Template = {
    templateId: 0,
    name: '',
    description: '',
    structure: {}
  }

  get content() {
    return { json: this.templateSave.structure, text: undefined }
  }

  created() {
    this.updateTemplateSave()
  }

  private updateTemplateSave() {
    this.templateSave.templateId = this.template.templateId
    this.templateSave.name = this.template.name
    this.templateSave.description = this.template.description
    this.templateSave.structure = this.template.structure
  }

  private formOk(): boolean {
    return !!this.templateSave.name && !!this.templateSave.description && !!this.templateSave.structure
  }

  hideModal() {
    this.$bvModal.hide('saveTemplateModal')
  }

  onChange(content: any) {
    this.templateSave.structure = content.json
  }

  private saveTemplate(): void {
    if (this.formOk()) {
      if (this.templateSave.templateId > 0) {
        ApiClient.updateTemplate(this.templateSave.templateId, this.templateSave)
          .then((templateSaved: Template) => {
            this.$emit('templateSaved', templateSaved)
            this.hideModal()
            this.clearForm()
          })
          .catch((ex: Error) => {
            alert(`Error: ${ex.message}`)
          })
      } else {
        ApiClient.createTemplate(this.templateSave)
          .then((templateSaved: Template) => {
            this.$emit('templateSaved', templateSaved)
            this.hideModal()
            this.clearForm()
          })
          .catch((ex: Error) => {
            alert(`Error: ${ex.message}`)
          })
      }
    } else {
      alert('Form not valid!')
    }
  }

  private clearForm() {
    this.templateSave.templateId = 0
    this.templateSave.name = ''
    this.templateSave.description = ''
    this.templateSave.structure = {}
  }
}
